import React from "react";
import "./CircularImage.css"; // Ensure you have a CSS file for styles

const CircularImage = ({ src, alt = "Profile", size = 150 }) => {
  return (
    <div
      className="circular-image"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default CircularImage;
